import React, { useState } from 'react';
import { Container, Card, Row, Col, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';
import GoogleLoginButton from '../../components/common/GoogleLoginButton';
import { adminGoogleLogin } from '../../api/authApi';
import { GoogleOAuthProvider } from '@react-oauth/google';

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    try {
      setLoading(true);
      setError('');
      
      const response = await adminGoogleLogin(credentialResponse);
      
      if (response.tokens) {
        login({ 
          email: response.email || '',
          is_staff: true 
        }, response.tokens);
        
        toast.success('Admin login successful!');
        navigate('/admin/dashboard');
      } else {
        setError('Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message || 'Only authorized admin accounts can login here.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <h2>Placement Unit Admin Login</h2>
                  <p className="text-muted">Admin access only</p>
                </div>
                
                {error && <Alert variant="danger">{error}</Alert>}
                
                <div className="d-grid gap-3">
                  <GoogleLoginButton 
                    onSuccess={handleGoogleLoginSuccess} 
                    disabled={loading}
                  />
                  
                  {loading && 
                    <div className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  }
                  
                  <div className="text-center mt-3">
                    <small className="text-muted">
                      Note: Only authorized placement unit admin accounts can access this portal
                    </small>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </GoogleOAuthProvider>
  );
};

export default AdminLogin;